import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { InvestmentUserListPresenter } from './investment-user-list-presenter'
import { ManualShareSaleModal } from './manual-share-sale-modal'
import { investmentServices, opportunityServices } from '../../services'
import { InvestmentSearchParamsV1, UserRole } from '../../lib/types'
import { RootState } from '../../store'

function InvestmentsUserListContainer() {
  const navigate = useNavigate()
  const { projectId } = useParams()
  const { role, actionGrants } = useSelector((s: RootState) => s.gbcUser)
  const canManualSale =
    (role === UserRole.SUPERUSER || role === UserRole.CREDIBILA_ADMIN) &&
    actionGrants?.manualShareSale === true
  const [showManualSale, setShowManualSale] = useState(false)
  const [reloadKey, setReloadKey] = useState(0)
  const [project, setProject] = useState<{ opportunity_title?: string }>()
  const [investments, setInvestments] = useState([])
  const [searchParams, setSearchParams] = useState<InvestmentSearchParamsV1>({
    limit: '10',
    offset: '0',
    opportunity_id: projectId,
  })
  const [pagination, setPagination] = useState({
    total: 0,
    limit: 10,
    count: 5,
    offset: 0,
  })
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    if (projectId) {
      opportunityServices.getOpportunityById(projectId, false).then((response) => {
        if (response.status === 200) {
          setProject(response.data)
        }
      })
    }
  }, [projectId])

  useEffect(() => {
    const fetchAllInvestments = async () => {
      const data = await investmentServices.getInvestments(searchParams)
      if (data.status === 200) {
        setInvestments(data.investments)
        setPagination(data.pagination)
      }
    }
    fetchAllInvestments()
  }, [currentPage, searchParams, reloadKey])

  const handleSearchParams = async ({ name, value }: { name: string; value: string }) => {
    const { limit } = pagination
    setSearchParams({
      ...searchParams,
      offset: '0',
      limit: limit.toString(),
      [name]: value,
    })
    setCurrentPage(1)
    setPagination({ ...pagination, offset: 0 })
  }

  const resetSearchParams = async () => {
    setSearchParams({
      limit: '10',
      offset: '0',
      keyword: '',
      filterBy: '',
      sortBy: '',
      opportunity_id: projectId,
    })
  }

  const handleCurrentPage = (currentPage: number) => {
    const { limit } = pagination
    setCurrentPage(currentPage)
    setSearchParams({
      ...searchParams,
      offset: `${(currentPage - 1) * limit}`,
    })
    setPagination({ ...pagination, offset: (currentPage - 1) * limit })
  }

  const handleInvestorClick = (investorId: number) => {
    navigate(`/client/${investorId}/profile`)
  }

  return (
    <>
      {showManualSale && projectId && (
        <ManualShareSaleModal
          opportunityId={projectId}
          opportunityTitle={project?.opportunity_title}
          onClose={() => setShowManualSale(false)}
          onSuccess={() => setReloadKey((k) => k + 1)}
        />
      )}
      <InvestmentUserListPresenter
        canManualSale={canManualSale}
        onManualSaleClick={() => setShowManualSale(true)}
        project={project}
        pagination={pagination}
        handleCurrentPage={handleCurrentPage}
        currentPage={currentPage}
        resetSearchParams={resetSearchParams}
        searchParams={searchParams}
        handleSearchParams={handleSearchParams}
        investments={investments}
        handleInvestorClick={handleInvestorClick}
      />
    </>
  )
}

export { InvestmentsUserListContainer }
